import React from 'react';

import { cn } from '@app/shared/utils/common';

interface CardsProps extends React.HTMLProps<HTMLDivElement> {
  firstImageClassName?: string;
  secondIMageClassName?: string;
  className?: string;
}

export const Cards = ({ className, firstImageClassName, secondIMageClassName }: CardsProps) => {
  return (
    <div className={cn('absolute', className)}>
      <div
        className={cn(
          'absolute left-8 top-3 h-12 w-[29px] rotate-23 rounded-[3px]',
          'bg-home-number-gradient',
          firstImageClassName
        )}
      />
      <div
        className={cn(
          'absolute left-4 top-4 flex  h-12 w-[29px] -rotate-6 justify-center rounded-[2px] pt-1 text-[27px] font-semibold leading-none text-home-card-number-text',
          'bg-home-accent-gradient',
          secondIMageClassName
        )}
      >
        ?
      </div>
    </div>
  );
};
